module.exports = __webpack_public_path__ + "img/awaio-logotype-green.812586ea.svg";